<template>
  <div class="row">
    <LiFormInput
      v-model.number="modelValue"
      :type="props.isPrice ? 'currency' : 'number'"
      :label="label"
      :is-required="true"
      class="col-12"
      data-cy="form_range_picker_value"
      :input-class="isInvalidRange ? 'is-invalid' : ''"
      :locale="defaultLocale"
      @keydown="onKeydown"
      :currency="currency">
    </LiFormInput>
    <div class="col-12 mt-2" data-cy="form_range_picker_slider">
      <input v-model="modelValue" type="range" class="form-range mb-2" :min="minRange" :max="maxRange" step="1" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, watch } from 'vue';

import { FormInput as LiFormInput } from '@prospective/lithium';

import { defaultLocale } from '@/config/app';

const modelValue = defineModel<number>({ default: 0 });
const isInvalid = defineModel<boolean>('isInvalid', { default: false });

const props = withDefaults(
  defineProps<{
    label: string;
    minRange: number;
    maxRange: number;
    allowNegative?: boolean;
    allowDecimal?: boolean;
    isPrice?: boolean;
    currency?: string;
  }>(),
  { allowNegative: false, allowDecimal: false, isPrice: false }
);

const isInvalidRange = computed(() => {
  return modelValue.value < props.minRange || modelValue.value > props.maxRange;
});

const allowedRegexKeys = computed(() => {
  return props.allowNegative
    ? props.allowDecimal || props.isPrice
      ? /[0-9\.\-]/
      : /[0-9\-]/
    : props.allowDecimal || props.isPrice
      ? /[0-9\.]/
      : /[0-9]/;
});

/* --------------------------------- METHODS -------------------------------- */
const onKeydown = (event: KeyboardEvent) => {
  if (allowedRegexKeys.value.test(event.key) || event.key === 'Backspace' || event.key === 'Delete') {
    return;
  }
  event.preventDefault();
  event.stopPropagation();
};

/* ---------------------------------- WATCH --------------------------------- */
watch(isInvalidRange, (newValue) => {
  isInvalid.value = newValue;
});
</script>
